export default __webpack_public_path__ + "static/media/Cera_Scaglie_Multicolore_120x120_small.99828d31.jpg";